import type { QueryClient } from "@tanstack/react-query";
import type { Changeset } from "./proposalsApi";

// A repo's changesets are listed under TWO query keys — the editor's
// ChangeSetSwitcher (`my-changesets`) and the proposals page's ProposalList
// (`changesets`). Any mutation that changes a changeset's name or status must
// refresh BOTH, or whichever screen the user isn't on shows stale data.

/** Invalidate both changeset-list queries for a repo. */
export function invalidateChangesetLists(
  qc: QueryClient,
  slug: string,
  repo: string,
): void {
  qc.invalidateQueries({ queryKey: ["my-changesets", slug, repo] });
  qc.invalidateQueries({ queryKey: ["changesets", slug, repo] });
}

/**
 * Write a fresh changeset into the detail cache (`["changeset", slug, repo,
 * number]` — the editor keys on the per-repo number) so the header's
 * name/status update immediately, without a refetch round-trip.
 */
export function cacheChangeset(
  qc: QueryClient,
  slug: string,
  repo: string,
  cs: Changeset,
): void {
  qc.setQueryData(["changeset", slug, repo, cs.number], cs);
}
